import { call, takeLatest, put } from "redux-saga/effects"
import { fetchError } from "appRedux/slices/common"
import toastr from "toastr"
import {
  getPageEntitiesByLanguageLocations,
  getPageEntitiesByLanguageLocationsSuccess,
  getPageList,
  getPageListSuccess,
  removePageEntityByLocation,
  removePageEntityByLocationSuccess,
  reorderPageEntities,
  reorderPageEntitiesSuccess,
  reorderDefaultPageEntities,
  reorderDefaultPageEntitiesSuccess,
  removePageEntity,
  removePageEntitySuccess,
  upsertPageEntitySuccess,
  upsertPageEntity,
  getPageEntitiesSuccess,
  getPageEntities,
  getEntities,
  getEntitiesSuccess,
  upsertTargetPageEntities,
  upsertTargetPageEntitiesSuccess,
  getCollectionEntitiesGroups,
  getCollectionEntitiesGroupsSuccess,
  getCollectionEntities,
  getCollectionEntitiesSuccess,
  updateCollectionEntity,
  updateCollectionEntitySuccess,
  deleteCollectionEntity,
  deleteCollectionEntitySuccess,
  getCollectionEntitiesByLanguageLocations,
  getCollectionEntitiesByLanguageLocationsSuccess,
  reorderCollectionEntities,
  reorderCollectionEntitiesSuccess,
  upsertTargetCollectionEntities,
  upsertTargetCollectionEntitiesSuccess,
  removeCollectionEntityByLocation,
  removeCollectionEntityByLocationSuccess,
  upsertCollection,
  upsertCollectionSuccess,
  upsertEntity,
  upsertEntitySuccess,
  upsertCollectionEntitySuccess,
  upsertCollectionEntity,
  removePageTheme,
  removePageThemeSuccess,
  upsertPage,
  upsertPageSuccess,
  upsertPageTheme,
  upsertPageThemeSuccess,
  upsertWebGame,
  upsertWebGameSuccess,
  removeGame,
  removeGameSuccess,
  reorderDefaultCollectionEntities,
  reorderDefaultCollectionEntitiesSuccess,
} from "../../slices/zeroSearch"
import {
  requestCollectionEntitiesGroups,
  requestPageEntities,
  requestEntities,
  requestPageEntitiesByLanLoc,
  requestPageList,
  requestRemovePageEntity,
  requestRemovePageEntityByLocation,
  requestReorderPageEntities,
  requestDefaultReorderPageEntities,
  requestDefaultReorderCollectionEntities,
  requestUpsertPageEntities,
  requestUpsertTargetPageEntities,
  requestCollectionEntities,
  requestUpdateCollectionEntity,
  requestDeleteCollectionEntity,
  requestCollectionEntitiesByLanLoc,
  requestReorderCollectionEntities,
  requestUpsertTargetCollectionEntities,
  requestRemoveCollectionEntityByLocation,
  requestUpsertCollection,
  requestUpsertEntity,
  requestUpsertCollectionEntity,
  requestRemovePageTheme,
  requestUpsertPage,
  requestUpsertPageTheme,
  requestUpsertWebGame,
  requestRemoveGame,
} from "../requests/zeroSearch"
function* handlePageList(params) {
  try {
    const data = yield call(requestPageList, params)
    yield put(getPageListSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handlePageEntities(params) {
  try {
    const data = yield call(requestPageEntities, params)
    yield put(getPageEntitiesSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleEntities(params) {
  try {
    const data = yield call(requestEntities, params)
    yield put(getEntitiesSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handlePageEntitiesByLanLoc(params) {
  try {
    const data = yield call(requestPageEntitiesByLanLoc, params)
    yield put(getPageEntitiesByLanguageLocationsSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleCollectionEntitiesByLanguageLocations(params) {
  try {
    const data = yield call(requestCollectionEntitiesByLanLoc, params)
    yield put(getCollectionEntitiesByLanguageLocationsSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleReorderPageEntities(params) {
  try {
    toastr.info("Action in progress ...")
    const data = yield call(requestReorderPageEntities, params)
    yield put(reorderPageEntitiesSuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleDefaultReorderPageEntities(params) {
  try {
    toastr.info("Action in progress ...")
    const data = yield call(requestDefaultReorderPageEntities, params)
    yield put(reorderDefaultPageEntitiesSuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleDefaultReorderCollectionEntities(params) {
  try {
    toastr.info("Action in progress ...")
    const data = yield call(requestDefaultReorderCollectionEntities, params)
    yield put(reorderDefaultCollectionEntitiesSuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleReorderCollectionEntities(params) {
  try {
    toastr.info("Action in progress ...")
    const data = yield call(requestReorderCollectionEntities, params)
    yield put(reorderCollectionEntitiesSuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleGetCollectionEntitiesGroups(params) {
  try {
    const data = yield call(requestCollectionEntitiesGroups, params)
    yield put(getCollectionEntitiesGroupsSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleGetCollectionEntities(params) {
  try {
    const data = yield call(requestCollectionEntities, params)
    yield put(getCollectionEntitiesSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleRemovePageEntityByLocation(params) {
  try {
    toastr.info("Action in progress ...")
    const data = yield call(requestRemovePageEntityByLocation, params)
    yield put(removePageEntityByLocationSuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleRemoveCollectionEntityByLocation(params) {
  try {
    toastr.info("Action in progress ...")
    const data = yield call(requestRemoveCollectionEntityByLocation, params)
    yield put(removeCollectionEntityByLocationSuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleRemovePageEntity(params) {
  try {
    toastr.info("Action in progress ...")
    const data = yield call(requestRemovePageEntity, params)
    yield put(removePageEntitySuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleRemoveGame(params) {
  try {
    toastr.info("Action in progress ...")
    const data = yield call(requestRemoveGame, params)
    yield put(removeGameSuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleDeleteCollectionEntity(params) {
  try {
    toastr.info("Action in progress ...")
    const data = yield call(requestDeleteCollectionEntity, params)
    yield put(deleteCollectionEntitySuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleRemovePageTheme(params) {
  try {
    toastr.info("Action in progress ...")
    const data = yield call(requestRemovePageTheme, params)
    yield put(removePageThemeSuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleUpsertPageEntity(params) {
  try {
    toastr.info("Action in progress ...")
    const data = yield call(requestUpsertPageEntities, params)
    yield put(upsertPageEntitySuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleUpsertCollection(params) {
  try {
    toastr.info("Action in progress ...")
    const data = yield call(requestUpsertCollection, params)
    yield put(upsertCollectionSuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleUpsertEntity(params) {
  try {
    toastr.info("Action in progress ...")
    const data = yield call(requestUpsertEntity, params)
    yield put(upsertEntitySuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleUpsertWebGame(params) {
  try {
    toastr.info("Action in progress ...")
    const data = yield call(requestUpsertWebGame, params)
    yield put(upsertWebGameSuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleUpsertPage(params) {
  try {
    toastr.info("Action in progress ...")
    const data = yield call(requestUpsertPage, params)
    yield put(upsertPageSuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleUpsertPageTheme(params) {
  try {
    toastr.info("Action in progress ...")
    const data = yield call(requestUpsertPageTheme, params)
    yield put(upsertPageThemeSuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleUpsertTargetPageEntities(params) {
  try {
    toastr.info("Action in progress ...")
    const data = yield call(requestUpsertTargetPageEntities, params)
    yield put(upsertTargetPageEntitiesSuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleUpsertTargetCollectionEntities(params) {
  try {
    toastr.info("Action in progress ...")
    const data = yield call(requestUpsertTargetCollectionEntities, params)
    yield put(upsertTargetCollectionEntitiesSuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleUpdateCollectionEntity(params) {
  try {
    toastr.info("Action in progress ...")
    const data = yield call(requestUpdateCollectionEntity, params)
    yield put(updateCollectionEntitySuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleUpsertCollectionEntity(params) {
  try {
    toastr.info("Action in progress ...")
    const data = yield call(requestUpsertCollectionEntity, params)
    yield put(upsertCollectionEntitySuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

export default function* watcherSaga() {
  yield takeLatest(getPageList.type, handlePageList)
  yield takeLatest(getPageEntities.type, handlePageEntities),
    yield takeLatest(getEntities.type, handleEntities),
    yield takeLatest(
      getPageEntitiesByLanguageLocations.type,
      handlePageEntitiesByLanLoc
    ),
    yield takeLatest(reorderPageEntities.type, handleReorderPageEntities),
    yield takeLatest(
      reorderDefaultPageEntities.type,
      handleDefaultReorderPageEntities
    ),
    yield takeLatest(
      reorderDefaultCollectionEntities.type,
      handleDefaultReorderCollectionEntities
    )
  yield takeLatest(
    reorderCollectionEntities.type,
    handleReorderCollectionEntities
  ),
    yield takeLatest(
      removePageEntityByLocation.type,
      handleRemovePageEntityByLocation
    ),
    yield takeLatest(
      removeCollectionEntityByLocation.type,
      handleRemoveCollectionEntityByLocation
    ),
    yield takeLatest(removePageEntity.type, handleRemovePageEntity)
  yield takeLatest(removeGame.type, handleRemoveGame)
  yield takeLatest(upsertPageEntity.type, handleUpsertPageEntity)
  yield takeLatest(upsertCollection.type, handleUpsertCollection)
  yield takeLatest(upsertEntity.type, handleUpsertEntity)
  yield takeLatest(upsertWebGame.type, handleUpsertWebGame)
  yield takeLatest(upsertPage.type, handleUpsertPage)
  yield takeLatest(upsertPageTheme.type, handleUpsertPageTheme)
  yield takeLatest(
    upsertTargetPageEntities.type,
    handleUpsertTargetPageEntities
  )
  yield takeLatest(
    upsertTargetCollectionEntities.type,
    handleUpsertTargetCollectionEntities
  )
  yield takeLatest(
    getCollectionEntitiesGroups.type,
    handleGetCollectionEntitiesGroups
  ),
    yield takeLatest(getCollectionEntities.type, handleGetCollectionEntities)
  yield takeLatest(updateCollectionEntity.type, handleUpdateCollectionEntity)
  yield takeLatest(upsertCollectionEntity.type, handleUpsertCollectionEntity)
  yield takeLatest(deleteCollectionEntity.type, handleDeleteCollectionEntity),
    yield takeLatest(removePageTheme.type, handleRemovePageTheme),
    yield takeLatest(
      getCollectionEntitiesByLanguageLocations.type,
      handleCollectionEntitiesByLanguageLocations
    )
}
